import DollarTagIcon from '../../../../../icons/dollar-tag.svg';
import HandSelectClickIcon from '../../../../../icons/hand-select-click.svg';
import UserIcon from '../../../../../icons/user.svg';
import DocumentIcon from '../../../../../icons/document.svg';
import CalculatorIcon from '../../../../../icons/calculator.svg';

export default function PurchasingProcessData() {
  return {
    subtitle: "Using Covr's Loan Protection Life Insurance Quoter gives you the best choices from the market.",
    image: "/product-landing/term/circle1.png",
    steps: [
      {
        title: "Get a Quote",
        icon: DollarTagIcon,
        paragraphs: [
          "Covr makes it easy! Simply use the online quoter to enter your information and see an instant quote from the life insurance company.",
        ]
      },
      {
        title: "The Application Process",
        icon: HandSelectClickIcon,
        paragraphs: [
          "To start your application, simply enter your personal information, beneficiary information and medical history. Sign the application digitally.",
        ]
      },
      {
        title: "Underwriting and decision",
        icon: UserIcon,
        paragraphs: [
          "Once you sign the application, the life insurance company will make a decision based on the information provided in your application - no medical exam required.",
        ],
      },
      {
        title: "Accepting your policy",
        icon: DocumentIcon,
        paragraphs: [
          "Assuming you accept the offer, your life insurance policy will be physically mailed from the life insurance company. If your application is declined, don't worry - one of our licensed concierge team members will reach out to discuss other carrier and product options to help you obtain the coverage you need.",
        ]
      }
    ]
  }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Americo/PurchasingProcessData.js